import { setCookie } from 'nookies'

import { DAY } from 'constants/seconds'
import { SESSION_TOKEN } from 'constants/cookies'
import { getCurrentUser, getCurrentUserWithSurvey } from './queries.graphql'
import { signInToken } from './mutations.graphql'

const withCurrentUser = callback => async appCtx => {
  const {
    apolloClient,
    ctx: {
      query: { token },
      pathname,
    },
  } = appCtx

  if (token) {
    const res = await apolloClient.mutate({
      mutation: signInToken,
      variables: { token },
    })
    const { sessionToken } = res.data.signInToken

    if (sessionToken) {
      setCookie(appCtx.ctx, SESSION_TOKEN, sessionToken, {
        path: '/',
        maxAge: 30 * DAY,
      })
      // hack for auth in SSR
      appCtx.ctx.overrideCookies = { [SESSION_TOKEN]: sessionToken }
    }
  }

  const isClientSignUpPage = pathname === '/client-sign-up'

  const currentUserPayload = await apolloClient.query({
    query: isClientSignUpPage ? getCurrentUserWithSurvey : getCurrentUser,
    fetchPolicy: 'network-only',
  })

  return callback({ ...appCtx, currentUserPayload })
}

export default withCurrentUser
